import { useState, useEffect } from "react";

// Live-ticking Dd Hh Mm Ss countdown to a target Date. Renders nothing if no
// target is given, and a short "started" message once the target has passed.
export default function Countdown({ target, doneLabel = "Started", labelColor = "rgba(255,255,255,0.4)", numberColor = "white" }) {
  const [now, setNow] = useState(Date.now());

  useEffect(() => {
    if (!target) return;
    const id = setInterval(() => setNow(Date.now()), 1000);
    return () => clearInterval(id);
  }, [target]);

  if (!target) return null;
  const diff = target.getTime() - now;
  if (diff <= 0) return <span style={{ color: numberColor, fontWeight: 700, fontSize: 13 }}>{doneLabel}</span>;

  const totalSeconds = Math.floor(diff / 1000);
  const days = Math.floor(totalSeconds / 86400);
  const hours = Math.floor((totalSeconds % 86400) / 3600);
  const minutes = Math.floor((totalSeconds % 3600) / 60);
  const seconds = totalSeconds % 60;

  return (
    <div style={{ display: "flex", gap: 12 }}>
      {[[days, "DAYS"], [hours, "HRS"], [minutes, "MIN"], [seconds, "SEC"]].map(([val, label]) => (
        <div key={label} style={{ textAlign: "center", minWidth: 32 }}>
          <div style={{ fontSize: 20, fontWeight: 900, color: numberColor, fontVariantNumeric: "tabular-nums", letterSpacing: -0.5 }}>{String(val).padStart(2, "0")}</div>
          <div style={{ fontSize: 9, color: labelColor, letterSpacing: 1, fontWeight: 700 }}>{label}</div>
        </div>
      ))}
    </div>
  );
}
